module.exports = __webpack_public_path__ + "img/hualpen.9cc322a6.jpg";